<template>
  <div class="wrap talk">
    <div class="container">
      <main class="content" style="height: 100vh; overflow: scroll;">
        <article class="certification atm">
          <section style="padding: 0 0.5rem">
            <div class="con-box">
              <h2>ATM 정보<span>정기 유지보수 결과를 입력해주세요.</span></h2>
              <div class="form-wrap">
                <dl class="row row_jsb row_ac">
                  <dt>ATM 찾기</dt>
                  <dd class="width50">
                    <input
                      type="text"
                      class="t-input"
                      placeholder="COM 번호를 입력하세요"
                      v-model="mntcData.prchChnlAfliNum"
                    />
                  </dd>
                  <dd class="btn-wrap">
                    <a class="btn bg-default" @click="findAtmInfo">찾기</a>
                  </dd>
                </dl>
                <div class="info-inp">
                  <input
                    type="text"
                    class="t-input"
                    v-model="mntcData.atmInfo"
                    disabled
                  />
                </div>
                <dl class="row row_jsb row_ac">
                  <dt>
                    <span class="icon_require point"/>
                    등록일시
                  </dt>
                  <dd>
                    <div class="input-area">
                      <div class="wp100">
                        <DxDateBox
                          v-model="mntcData.regDt"
                          class="wp100"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          styling-mode="outlined"
                        />
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>
                    특이사항 유형
                  </dt>
                  <dd>
                    <div class="input-area">
                      <div class="label-check wp100">
                        <DxSelectBox
                          :dataSource="atmMntcPecuCdList"
                          displayExpr="cmnsCdNm"
                          valueExpr="cmnsCd"
                          height="30px"
                          placeholder="선택하세요."
                          v-model="mntcData.atmMntcPecuCd"
                        />
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>( {{ mntcData.atmMntcPecuCtts.length }} / 200)</dt>
                  <dd class="h-textarea">
                    <textarea
                      id="atmMntcPecuCtts"
                      cols="30"
                      rows="10"
                      class="textBox h-100"
                      style="line-height: 15px !important; height: 60px; resize: none;"
                      v-model="mntcData.atmMntcPecuCtts"
                    />
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>
                    <span class="icon_require point"/>
                    ATM상세위치
                  </dt>
                  <dd>
                    <div class="input-area">
                      <div class="label-check wp100">
                        <DxSelectBox
                          :dataSource="atmMntcDtlLocList"
                          displayExpr="cmnsCdNm"
                          valueExpr="cmnsCd"
                          height="30px"
                          placeholder="선택하세요."
                          v-model="mntcData.atmMntcDtlLoc"
                        />
                      </div>
                    </div>
                  </dd>
                </dl>
                <dl class="row row_jsb row_ac">
                  <dt>( {{ mntcData.atmMntcDtlLocCtts.length }} / 200)</dt>
                  <dd class="h-textarea">
                    <textarea
                      id="atmMntcDtlLocCtts"
                      cols="30"
                      rows="10"
                      class="textBox h-100"
                      style="line-height: 15px !important; height: 60px; resize: none;"
                      v-model="mntcData.atmMntcDtlLocCtts"
                    />
                  </dd>
                </dl>
                <template v-if="false && 'BOSA-121'">
                  <dl class="row row_jsb row_ac">
                    <dt>외관</dt>
                    <dd>
                      <div class="input-area">
                        <div class="label-check">
                          <RadioCodeListType3
                            name="extlChckStatCd"
                            cmnsCdGrpId="ATM_MNTC_EXTL_CD"
                            :value="mntcData.extlChckStatCd"
                            @input="
                              value =>
                                handleExtlChckStatCd(value, 'extlChckStatCd')
                            "
                          />
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac">
                    <dt>촬영함</dt>
                    <dd>
                      <div class="input-area">
                        <div class="label-check">
                          <RadioCodeListType3
                            name="cmraExtlChckStatCd"
                            cmnsCdGrpId="ATM_MNTC_EXTL_CD"
                            :value="mntcData.cmraExtlChckStatCd"
                            @input="
                              value =>
                                handleExtlChckStatCd(value, 'cmraExtlChckStatCd')
                            "
                          />
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac mb_30">
                    <dt>케이블</dt>
                    <dd>
                      <div class="input-area">
                        <div class="label-check n5">
                          <label>
                            <input
                              type="checkbox"
                              v-model="mntcData.cablChckStatCd"
                              @change="onChangeCable"
                            />
                            <span>정상</span>
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              v-model="mntcData.cb5pChckStatCd"
                              @change="onChange5pCable"
                            />
                            <span>5핀</span>
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              v-model="mntcData.cb8pChckStatCd"
                              @change="onChange8pCable"
                            />
                            <span>8핀</span>
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              v-model="mntcData.cbctChckStatCd"
                              @change="onChangecCable"
                            />
                            <span>C-Type</span>
                          </label>
                        </div>
                      </div>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac">
                    <dt>바코드용지</dt>
                    <dd>
                      <div class="label-check n6">
                        <label>
                          <input
                            type="radio"
                            value="1"
                            v-model="mntcData.brcdStatCd"
                          />
                          <span>교체</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="2"
                            v-model="mntcData.brcdStatCd"
                          />
                          <span>30%이상</span>
                        </label>
                        <label>
                          <input
                            type="radio"
                            value="3"
                            v-model="mntcData.brcdStatCd"
                          />
                          <span>고장</span>
                        </label>
                      </div>
                    </dd>
                  </dl>
                  <dl class="row row_jsb row_ac">
                    <dt>특이사항</dt>
                    <dd>
                      <input
                        type="text"
                        class="t-input"
                        placeholder="특이사항 메모해주세요"
                        v-model="mntcData.spntCtts"
                      />
                    </dd>
                  </dl>
                </template>
                <dl class="row row_jsb row_ac">
                  <dt>첨부 이미지</dt>
                  <dd class="h-textarea" @click="mntcImgFileInputClick">
                    <button type="button" class="btn-file" style="position: relative; z-index: 1; top: 2px">파일선택</button>
                    <textarea
                      id="atmMntcFileNameList"
                      cols="30"
                      rows="10"
                      class="textBox h-100"
                      readonly
                      style="line-height: 15px !important; height: 60px; resize: none; position: relative; top: -22px;"
                      v-model="getMntcFileNameList"
                    />
                  </dd>
                </dl>
                <template v-if="imageList && imageList.length > 0">
                  <dl class="row row_jsb row_ac">
                    <dt>
                      <img :src="imageUrls[0]" style="width: 250px;" />
                    </dt>
                    <dd>
                      <div class="input-area">
                        <a
                          class="btn bg-default"
                          @click="
                            () => {
                              isImageVisible = true;
                            }
                          "
                          >이미지 보기</a
                        >
                        <a class="btn bg-default" @click="deleteImage()"
                          >이미지 삭제</a
                        >
                      </div>
                    </dd>
                    <div v-if="isImageVisible" class="image-viewer">
                      <span
                        class="close"
                        @click="
                          () => {
                            isImageVisible = false;
                          }
                        "
                        >&times;</span
                      >
                      <div v-for="(imgItem, idx) in imageUrls" :key="`image-url-${idx}`">
                        <img
                          class="modal-content"
                          id="full-image"
                          :src="imgItem"
                        />
                      </div>
                    </div>
                  </dl>
                </template>
              </div>
            </div>
          </section>
          <div class="btn-wrap">
            <a class="regist-btn btn-black" @click="mntcUpdate">수정</a>
            <a class="list-btn btn-black" @click="gotoatmMntcHstr">리스트</a>
          </div>
        </article>
      </main>
    </div>
    <Camera @popupComplete="cameraJobDone"/>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import AppConfig from '@/config'
import {mapGetters} from 'vuex'
import { IMG_SERVER_URL } from '../customerCare'

import RadioCodeListType3 from '@/components/RadioCodeListType3.vue'
import Camera from '@/components/Camera.vue'
import DxDateBox from 'devextreme-vue/date-box'
import DxSelectBox from 'devextreme-vue/select-box'

export default {
  name: 'AtmMntcHstUpdate',
  components: {
    RadioCodeListType3,
    Camera,
    DxDateBox,
    DxSelectBox
  },
  props: [
    'atmMntcHstrNum'
  ],
  data () {
    return {
      mntcData: {
        atmMntcHstrNum: '',
        bsncNum: '',
        atmInfo: '',
        atmNum: '',
        extlChckStatCd: '',
        cmraExtlChckStatCd: '',
        cablChckStatCd: false,
        cb5pChckStatCd: false,
        cb8pChckStatCd: false,
        cbctChckStatCd: false,
        apndImageNm: '',
        atmMntcPecuCd: '',
        atmMntcDtlLoc: '',
        regDt: moment().format('yyyy-MM-DD'),
        atmMntcPecuCtts: '',
        atmMntcDtlLocCtts: ''
      },
      mntcFiles: [],
      mntcFileNameList: [],
      imageList: [],
      isImageVisible: false,
      atmMntcPecuCdList: [],
      atmMntcDtlLocList: [],
      isShowAtmMntcPecuCtts: false,
      isShowAtmMntcDtlLocCtts: false
    }
  },
  computed: {
    ...mapGetters('Login', {
      userId: 'getUserId'
    }),
    ...mapGetters('LatestMenu', {
      latestMenuList: 'getLatestMenuList',
      current: 'getCurrent'
    }),
    imageUrls () {
      return this.imageList.map(obj => {
        return IMG_SERVER_URL + obj.fileName
      })
    },
    getStoreCompObjs () {
      return window.$store.getters['ModalStore/getModalObjs']
    },
    getMntcFileNameList () {
      if (this.mntcFiles && this.mntcFiles.length > 0) {
        return this.mntcFiles.map(obj => obj.name).join('\n')
      }
      return this.imageList.map(obj => obj.fileName).join('\n')
    }
  },
  watch: {
    async routeParamsAtmMntcHstrNum () {
      if (!this.routeParamsAtmMntcHstrNum) return
      this.mounted()
    },
    atmMntcHstrNum (newVal) {
      console.log('>>>> > file: AtmMntcHstrUpdate.vue:180 > atmMntcHstrNum > newVal', newVal)
    },
    'mntcData.atmMntcPecuCd' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isShowAtmMntcPecuCtts = newVal === 'DR_WRT'
        if (!this.isShowAtmMntcPecuCtts) {
          this.mntcData.atmMntcPecuCtts = ''
        }
      }
    },
    'mntcData.atmMntcDtlLoc' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.isShowAtmMntcDtlLocCtts = newVal === '900'
        if (!this.isShowAtmMntcDtlLocCtts) {
          this.mntcData.atmMntcDtlLocCtts = ''
        }
      }
    }
  },
  methods: {
    handleExtlChckStatCd (value, trgtDataName) {
      Object.assign(this.mntcData, { [trgtDataName]: value })
    },
    mntcImgFileInputClick () {
      this.$modal.show('cameraModal', { limitCnt: 5 })
    },
    onChangeCable (e) {
      if (this.mntcData.cablChckStatCd === true) {
        // 정상이면 다른 것은 해제
        this.mntcData.cb5pChckStatCd = false
        this.mntcData.cb8pChckStatCd = false
        this.mntcData.cbctChckStatCd = false
      }
    },
    onChange5pCable (e) {
      if (this.mntcData.cb5pChckStatCd === true) {
        // 5핀 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    onChange8pCable (e) {
      if (this.mntcData.cb8pChckStatCd === true) {
        // 8핀 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    onChangecCable (e) {
      if (this.mntcData.cbctChckStatCd === true) {
        // C-type 체크시 정상은 해제
        this.mntcData.cablChckStatCd = false
      }
    },
    findAtmInfo () {
      if (this.mntcData.bsncNum == null || this.mntcData.bsncNum.length === 0) {
        window.$Alert.alert('COM 번호를 입력하세요~')
        return
      }
      Vue.httpClient.get('/api/purchase/customerCare/atmMntcHstrBsncnum', {params: { ...this.mntcData }})
        .then((response) => {
          if (response && response.data && response.data.result) {
            const prchChnlAfliObj = response.data.result
            if (!prchChnlAfliObj) {
              this.mntcData.atmNum = ''
              this.mntcData.atmInfo = ''
              window.$Alert.alert('COM번호를 확인해 주세요!')
              return
            } else {
              this.mntcData.atmNum = prchChnlAfliObj.atmNum
              this.mntcData.atmInfo = prchChnlAfliObj.atmInfo
            }
          } else {
            this.mntcData.atmNum = ''
            this.mntcData.atmInfo = ''
            window.$Alert.alert('COM번호를 확인해 주세요!')
          }
        })
    },
    async mntcUpdate () {
      if (!this.mntcData.bsncNum) {
        window.$Alert.alert('COM 번호를 입력하세요~')
        return
      }
      if (!this.mntcData.regDt) {
        window.$Alert.alert('등록일을 선택하세요.')
        return
      }
      if (!this.mntcData.extlChckStatCd) {
        // window.$Alert.alert('외관을 선택하세요~')
        // return
      }
      if (!this.mntcData.cmraExtlChckStatCd) {
        // window.$Alert.alert('촬영함을 선택하세요~')
        // return
      }
      if (this.mntcData.cablChckStatCd === false &&
          this.mntcData.cb5pChckStatCd === false &&
          this.mntcData.cb8pChckStatCd === false &&
          this.mntcData.cbctChckStatCd === false) {
        // window.$Alert.alert('케이블을 선택하세요~')
        // return
      }
      if (this.mntcData.brcdStatCd === false) {
        // window.$Alert.alert('바코드를 선택하세요~')
        // return
      }
      if (this.mntcData.spntCtts && this.mntcData.spntCtts.length > 200) {
        // window.$Alert.alert('특이사항은 최대 200자 입니다.')
        // return
      }
      if (!this.mntcData.atmMntcPecuCd) {
        // window.$Alert.alert('특이사항 유형을 선택하세요.')
        // return false
      }
      if (!this.mntcData.atmMntcDtlLoc) {
        window.$Alert.alert('ATM상세위치를 선택하세요.')
        return false
      }
      if (this.mntcData.atmMntcPecuCd === 'DR_WRT' && !this.mntcData.atmMntcPecuCtts.length) {
        window.$Alert.alert('특이사항을 직접 입력해 주세요.')
        return
      }
      if (this.mntcData.atmMntcPecuCtts && this.mntcData.atmMntcPecuCtts.length > 200) {
        window.$Alert.alert('특이사항은 최대 200자 입니다.')
        return
      }
      if (this.mntcData.atmMntcDtlLoc === '900' && !this.mntcData.atmMntcDtlLocCtts.length) {
        window.$Alert.alert('ATM 상세위치를 직접 입력해 주세요.')
        return
      }
      if (this.mntcData.atmMntcDtlLocCtts && this.mntcData.atmMntcDtlLocCtts.length > 200) {
        window.$Alert.alert('ATM 상세위치는 최대 200자 입니다.')
        return
      }

      if (this.mntcData.atmMntcPecuCd === 'BRER_ATCH' && (this.mntcFiles === '' || this.mntcFiles.length <= 0)) {
        window.$Alert.alert('이미지를 등록해주세요.')
        return false
      }

      const confirm = await this.$Alert.confirm('수정 하시겠습니까?')
      if (!confirm) return

      if (this.mntcFiles && this.mntcFiles.length > 0) {
        const tempFileNameList = `${await this.upload(this.mntcFiles)}`
        if (tempFileNameList.includes('/%/')) {
          this.mntcFileNameList = tempFileNameList.split('/%/').map(fileName => fileName)
        }else{
          this.mntcData.mntcFileNameList = (Array.isArray(tempFileNameList) ? tempFileNameList : [tempFileNameList]).map(fileName => fileName)
        }
      }

      Vue.httpClient.post('/api/purchase/customerCare/atmMntcHstrUpdate',
        {
          ...this.mntcData,
          mntcFileNameList: this.mntcFileNameList,
          mobile: 'mobile'
        })
        .then((response) => {
          if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            // this.$Alert.("정기유지보수가 수정 되었습니다.");
            this.gotoatmMntcHstr(this.mntcData.atmMntcHstr)
          }
        })
    },
    async upload (uploadFiles) {
      const fd = new FormData()
      this.mntcFileNameList = []
      for (let uploadFile of uploadFiles) {
        fd.append('files', uploadFile)
        this.mntcFileNameList.push(uploadFile.name)
      }
      const { data } = await Vue.httpClient.post('/api/purchase/customerCare/imageUpload',
        fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )

      if (data.status === '200') {
        return data.result
      } else {
        return ''
      }
    },
    async deleteImage () {
      if (this.imageList && this.imageList.length > 0) {
        const confirm = await this.$Alert.confirm('이미지를 삭제하시겠습니까')
        if (!confirm) return

        Vue.httpClient.post('/api/purchase/customerCare/updateAtmMntcHstrApndFlInfo', { ...this.mntcData })
          .then((response) => {
            if (response.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
              this.imageList = []
            }
          })
      }
    },
    gotoatmMntcHstr (atmMntcHstrNum) {
      // ATM 정기유지보수 리스트 화면으로 전환하기
      if (this.$route.params.atmMntcHstrNum != null) {
        this.$router.push({name: 'AtmMntcHstr', params: { atmMntcHstrNum }})
      } else if (this.atmMntcHstrNum) {
        window.$store.commit('ModalStore/hideModal', this.getStoreCompObjs.length - 1)
      }
    },
    async atmMntcHstrList (atmMntcHstrNum) {
      const { data } = await Vue.httpClient.get('/api/purchase/customerCare/atmMntcHstrList', {params: { ...this.mntcData, atmMntcHstrNum }})
      this.mntcData = data.result.list[0]
    },
    async selectAtmMntcHstrImgList (atmMntcHstrNum) {
      const res = await this.$http.get('/api/purchase/customerCare/selectAtmMntcHstrImgList',
        {
          params: {
            ...this.mntcData,
            atmMntcHstrNum,
            startDate: this.mntcData.workDate,
            endDate: this.mntcData.workDate
          }
        })

      this.imageList = []
      if (res) {
        const { data: { status, result } } = res

        if (result && status === '200') {
          this.imageList = [...result]
        }
      }
    },
    async getCommCdList (cmnsCdGrpId) {
      const params = { cmnsCdGrpId }
      const res = await this.$http.get('/api/appmgmt/common/code/list', {params, data: {isLoadingHide: 'Y'}})

      if (res) {
        const { data: { result } } = res
        return result
      }
      return []
    },
    cameraJobDone (files) {
      this.mntcFiles = []
      for (let file of files) {
        console.log('>>>> > file: AtmMntcHstrInsert.vue:797 > cameraJobDone > file', file)
        this.mntcFiles.push(file)
      }
    }
  },
  async mounted () {
    // 초기화 작업
    this.mntcData = {}
    this.mntcFiles = ''
    if (this.$route.params.atmMntcHstrNum != null) {
      await this.atmMntcHstrList(this.$route.params.atmMntcHstrNum)
      await this.selectAtmMntcHstrImgList(this.$route.params.atmMntcHstrNum)
    } else if (this.atmMntcHstrNum) {
      await this.atmMntcHstrList(this.atmMntcHstrNum)
      await this.selectAtmMntcHstrImgList(this.atmMntcHstrNum)
    }

    this.atmMntcPecuCdList = await this.getCommCdList('ATM_MNTC_PECU_CD')
    this.atmMntcDtlLocList = await this.getCommCdList('ATM_MNTC_DTL_LOC')

    await this.$nextTick()
  }
}
</script>

<style scoped>
.icon_require:before{content: '*'; display: inline-block; margin-right: 2px; font-weight: 700;}
</style>



// WEBPACK FOOTER //
// src/views/customerCare/AtmMntcHstrUpdate.vue